import React from 'react';

export const renderStageTitle = (stageId) => {
    return <div>Create Stage event (stage ID {stageId || ''})</div>;
};

